import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { componentKey } from './AuthenticationSlice';
import { componentKey as appSwitchComponentKey } from '../appswitch/AppSwitchSlice';
import { checkUserIsAuthenticated } from './AuthenticationSaga';
import Loadable from '../../components/loadable/Loadable';
import { APP_SWITCH_STATES } from '../appswitch/constants';

export default function Authentication({ children }) {

    const { authenticationLoader } = useSelector(state => state[componentKey]);
    const { appSwitchLoaderState } = useSelector(state => state[appSwitchComponentKey]);
    const dispatch = useDispatch();

    useEffect(() => {
        if (appSwitchLoaderState.state === APP_SWITCH_STATES.APP_SWITCH_READY) {
            dispatch(checkUserIsAuthenticated());
        }
    }, [appSwitchLoaderState]);


    return <Loadable currentState={authenticationLoader.state} isNewLoadable={true}>
        {children}
    </Loadable>
}